/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router';

import { Route as rootRouteImport } from './routes/__root';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as AuthRouteImport } from './routes/auth';
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index';
import { Route as AuthenticatedOwnerRouteImport } from './routes/_authenticated/$owner';
import { Route as AuthenticatedNoOrganizationRouteImport } from './routes/_authenticated/no-organization';
import { Route as AuthAcceptInvitationRouteImport } from './routes/auth/accept-invitation';
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password';
import { Route as AuthSigninRouteImport } from './routes/auth/signin';
import { Route as AuthSignupRouteImport } from './routes/auth/signup';
import { Route as AuthenticatedOwnerIndexRouteImport } from './routes/_authenticated/$owner/index';
import { Route as AuthenticatedOwnerGhostRouteImport } from './routes/_authenticated/$owner/ghost';
import { Route as AuthenticatedOwnerPlanRouteImport } from './routes/_authenticated/$owner/plan';
import { Route as AuthenticatedOwnerProjectionRouteImport } from './routes/_authenticated/$owner/projection';
import { Route as AuthenticatedOwnerScoutRouteImport } from './routes/_authenticated/$owner/scout';
import { Route as AuthenticatedOwnerSettingsRouteImport } from './routes/_authenticated/$owner/settings';
import { Route as AuthenticatedOwnerAccountSettingsRouteImport } from './routes/_authenticated/$owner/account/settings';
import { Route as AuthenticatedOwnerActivityIndexRouteImport } from './routes/_authenticated/$owner/activity/index';
import { Route as AuthenticatedOwnerDatabaseIndexRouteImport } from './routes/_authenticated/$owner/database/index';
import { Route as AuthenticatedOwnerPlayersIndexRouteImport } from './routes/_authenticated/$owner/players/index';
import { Route as AuthenticatedOwnerPlayersNewRouteImport } from './routes/_authenticated/$owner/players/new';
import { Route as AuthenticatedOwnerReportsIndexRouteImport } from './routes/_authenticated/$owner/reports/index';
import { Route as AuthenticatedOwnerSettingsIndexRouteImport } from './routes/_authenticated/$owner/settings/index';
import { Route as AuthenticatedOwnerSettingsAccessRouteImport } from './routes/_authenticated/$owner/settings/access';
import { Route as AuthenticatedOwnerSettingsSubscriptionRouteImport } from './routes/_authenticated/$owner/settings/subscription';
import { Route as AuthenticatedOwnerAccountSettingsIndexRouteImport } from './routes/_authenticated/$owner/account/settings/index';
import { Route as AuthenticatedOwnerAccountSettingsPasswordRouteImport } from './routes/_authenticated/$owner/account/settings/password';
import { Route as AuthenticatedOwnerAccountSettingsSessionsRouteImport } from './routes/_authenticated/$owner/account/settings/sessions';
import { Route as AuthenticatedOwnerAccountSettingsSignInRouteImport } from './routes/_authenticated/$owner/account/settings/sign-in';
import { Route as AuthenticatedOwnerAccountSettingsSubscriptionRouteImport } from './routes/_authenticated/$owner/account/settings/subscription';
import { Route as AuthenticatedOwnerActiveTeam_season_idIndexRouteImport } from './routes/_authenticated/$owner/active/$team_season_id.index';
import { Route as AuthenticatedOwnerActiveTeam_season_idCalendarRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/calendar';
import { Route as AuthenticatedOwnerActiveTeam_season_idDepthChartRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/depth-chart';
import { Route as AuthenticatedOwnerActiveTeam_season_idPortalRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/portal';
import { Route as AuthenticatedOwnerActiveTeam_season_idStatsRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/stats';
import { Route as AuthenticatedOwnerActivityIdIndexRouteImport } from './routes/_authenticated/$owner/activity/$id.index';
import { Route as AuthenticatedOwnerDatabaseIdIndexRouteImport } from './routes/_authenticated/$owner/database/$id.index';
import { Route as AuthenticatedOwnerPlanningTeam_season_idIndexRouteImport } from './routes/_authenticated/$owner/planning/$team_season_id.index';
import { Route as AuthenticatedOwnerPlayersIdIndexRouteImport } from './routes/_authenticated/$owner/players/$id.index';
import { Route as AuthenticatedOwnerPlayersIdEditRouteImport } from './routes/_authenticated/$owner/players/$id.edit';
import { Route as AuthenticatedOwnerReportsIdIndexRouteImport } from './routes/_authenticated/$owner/reports/$id.index';
import { Route as AuthenticatedOwnerActiveTeam_season_idLineupsIndexRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/lineups/index';
import { Route as AuthenticatedOwnerActiveTeam_season_idLineupsNewRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/lineups/new';
import { Route as AuthenticatedOwnerActiveTeam_season_idPlayersIndexRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/players/index';
import { Route as AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/practice-plans/index';
import { Route as AuthenticatedOwnerActiveTeam_season_idVideosIndexRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/videos/index';
import { Route as AuthenticatedOwnerActiveTeam_season_idVideosSystemsRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/videos/systems';
import { Route as AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/lineups/$id.index';
import { Route as AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/lineups/$id.edit';
import { Route as AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRouteImport } from './routes/_authenticated/$owner/active/$team_season_id/players/$id.index';

const AuthenticatedOwnerDesignLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design',
)();
const AuthenticatedOwnerDesignIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design/',
)();
const AuthenticatedOwnerDesignColorsLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design/colors',
)();
const AuthenticatedOwnerDesignFormsLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design/forms',
)();
const AuthenticatedOwnerDesignTablesLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design/tables',
)();
const AuthenticatedOwnerDesignTypographyLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design/typography',
)();

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedOwnerRoute = AuthenticatedOwnerRouteImport.update({
  id: '/$owner',
  path: '/$owner',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedNoOrganizationRoute =
  AuthenticatedNoOrganizationRouteImport.update({
    id: '/no-organization',
    path: '/no-organization',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthAcceptInvitationRoute = AuthAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => AuthRoute,
} as any);
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any);
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any);
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any);
const AuthenticatedOwnerIndexRoute = AuthenticatedOwnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedOwnerRoute,
} as any);
const AuthenticatedOwnerDesignLazyRoute =
  AuthenticatedOwnerDesignLazyRouteImport.update({
    id: '/design',
    path: '/design',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design.lazy').then((d) => d.Route),
  );
const AuthenticatedOwnerGhostRoute = AuthenticatedOwnerGhostRouteImport.update({
  id: '/ghost',
  path: '/ghost',
  getParentRoute: () => AuthenticatedOwnerRoute,
} as any);
const AuthenticatedOwnerPlanRoute = AuthenticatedOwnerPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => AuthenticatedOwnerRoute,
} as any);
const AuthenticatedOwnerProjectionRoute =
  AuthenticatedOwnerProjectionRouteImport.update({
    id: '/projection',
    path: '/projection',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerScoutRoute = AuthenticatedOwnerScoutRouteImport.update({
  id: '/scout',
  path: '/scout',
  getParentRoute: () => AuthenticatedOwnerRoute,
} as any);
const AuthenticatedOwnerSettingsRoute =
  AuthenticatedOwnerSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerAccountSettingsRoute =
  AuthenticatedOwnerAccountSettingsRouteImport.update({
    id: '/account/settings',
    path: '/account/settings',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActivityIndexRoute =
  AuthenticatedOwnerActivityIndexRouteImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerDatabaseIndexRoute =
  AuthenticatedOwnerDatabaseIndexRouteImport.update({
    id: '/database/',
    path: '/database/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerDesignIndexLazyRoute =
  AuthenticatedOwnerDesignIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOwnerDesignLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design/index.lazy').then(
      (d) => d.Route,
    ),
  );
const AuthenticatedOwnerDesignColorsLazyRoute =
  AuthenticatedOwnerDesignColorsLazyRouteImport.update({
    id: '/colors',
    path: '/colors',
    getParentRoute: () => AuthenticatedOwnerDesignLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design/colors.lazy').then(
      (d) => d.Route,
    ),
  );
const AuthenticatedOwnerDesignFormsLazyRoute =
  AuthenticatedOwnerDesignFormsLazyRouteImport.update({
    id: '/forms',
    path: '/forms',
    getParentRoute: () => AuthenticatedOwnerDesignLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design/forms.lazy').then(
      (d) => d.Route,
    ),
  );
const AuthenticatedOwnerDesignTablesLazyRoute =
  AuthenticatedOwnerDesignTablesLazyRouteImport.update({
    id: '/tables',
    path: '/tables',
    getParentRoute: () => AuthenticatedOwnerDesignLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design/tables.lazy').then(
      (d) => d.Route,
    ),
  );
const AuthenticatedOwnerDesignTypographyLazyRoute =
  AuthenticatedOwnerDesignTypographyLazyRouteImport.update({
    id: '/typography',
    path: '/typography',
    getParentRoute: () => AuthenticatedOwnerDesignLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design/typography.lazy').then(
      (d) => d.Route,
    ),
  );
const AuthenticatedOwnerPlayersIndexRoute =
  AuthenticatedOwnerPlayersIndexRouteImport.update({
    id: '/players/',
    path: '/players/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerPlayersNewRoute =
  AuthenticatedOwnerPlayersNewRouteImport.update({
    id: '/players/new',
    path: '/players/new',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerReportsIndexRoute =
  AuthenticatedOwnerReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerSettingsIndexRoute =
  AuthenticatedOwnerSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOwnerSettingsRoute,
  } as any);
const AuthenticatedOwnerSettingsAccessRoute =
  AuthenticatedOwnerSettingsAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedOwnerSettingsRoute,
  } as any);
const AuthenticatedOwnerSettingsSubscriptionRoute =
  AuthenticatedOwnerSettingsSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedOwnerSettingsRoute,
  } as any);
const AuthenticatedOwnerAccountSettingsIndexRoute =
  AuthenticatedOwnerAccountSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOwnerAccountSettingsRoute,
  } as any);
const AuthenticatedOwnerAccountSettingsPasswordRoute =
  AuthenticatedOwnerAccountSettingsPasswordRouteImport.update({
    id: '/password',
    path: '/password',
    getParentRoute: () => AuthenticatedOwnerAccountSettingsRoute,
  } as any);
const AuthenticatedOwnerAccountSettingsSessionsRoute =
  AuthenticatedOwnerAccountSettingsSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => AuthenticatedOwnerAccountSettingsRoute,
  } as any);
const AuthenticatedOwnerAccountSettingsSignInRoute =
  AuthenticatedOwnerAccountSettingsSignInRouteImport.update({
    id: '/sign-in',
    path: '/sign-in',
    getParentRoute: () => AuthenticatedOwnerAccountSettingsRoute,
  } as any);
const AuthenticatedOwnerAccountSettingsSubscriptionRoute =
  AuthenticatedOwnerAccountSettingsSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedOwnerAccountSettingsRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idIndexRoute =
  AuthenticatedOwnerActiveTeam_season_idIndexRouteImport.update({
    id: '/active/$team_season_id/',
    path: '/active/$team_season_id/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idCalendarRoute =
  AuthenticatedOwnerActiveTeam_season_idCalendarRouteImport.update({
    id: '/active/$team_season_id/calendar',
    path: '/active/$team_season_id/calendar',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idDepthChartRoute =
  AuthenticatedOwnerActiveTeam_season_idDepthChartRouteImport.update({
    id: '/active/$team_season_id/depth-chart',
    path: '/active/$team_season_id/depth-chart',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idPortalRoute =
  AuthenticatedOwnerActiveTeam_season_idPortalRouteImport.update({
    id: '/active/$team_season_id/portal',
    path: '/active/$team_season_id/portal',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idStatsRoute =
  AuthenticatedOwnerActiveTeam_season_idStatsRouteImport.update({
    id: '/active/$team_season_id/stats',
    path: '/active/$team_season_id/stats',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActivityIdIndexRoute =
  AuthenticatedOwnerActivityIdIndexRouteImport.update({
    id: '/activity/$id/',
    path: '/activity/$id/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerDatabaseIdIndexRoute =
  AuthenticatedOwnerDatabaseIdIndexRouteImport.update({
    id: '/database/$id/',
    path: '/database/$id/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerPlanningTeam_season_idIndexRoute =
  AuthenticatedOwnerPlanningTeam_season_idIndexRouteImport.update({
    id: '/planning/$team_season_id/',
    path: '/planning/$team_season_id/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerPlayersIdIndexRoute =
  AuthenticatedOwnerPlayersIdIndexRouteImport.update({
    id: '/players/$id/',
    path: '/players/$id/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerPlayersIdEditRoute =
  AuthenticatedOwnerPlayersIdEditRouteImport.update({
    id: '/players/$id/edit',
    path: '/players/$id/edit',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerReportsIdIndexRoute =
  AuthenticatedOwnerReportsIdIndexRouteImport.update({
    id: '/reports/$id/',
    path: '/reports/$id/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idLineupsIndexRoute =
  AuthenticatedOwnerActiveTeam_season_idLineupsIndexRouteImport.update({
    id: '/active/$team_season_id/lineups/',
    path: '/active/$team_season_id/lineups/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idLineupsNewRoute =
  AuthenticatedOwnerActiveTeam_season_idLineupsNewRouteImport.update({
    id: '/active/$team_season_id/lineups/new',
    path: '/active/$team_season_id/lineups/new',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idPlayersIndexRoute =
  AuthenticatedOwnerActiveTeam_season_idPlayersIndexRouteImport.update({
    id: '/active/$team_season_id/players/',
    path: '/active/$team_season_id/players/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRoute =
  AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRouteImport.update({
    id: '/active/$team_season_id/practice-plans/',
    path: '/active/$team_season_id/practice-plans/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idVideosIndexRoute =
  AuthenticatedOwnerActiveTeam_season_idVideosIndexRouteImport.update({
    id: '/active/$team_season_id/videos/',
    path: '/active/$team_season_id/videos/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idVideosSystemsRoute =
  AuthenticatedOwnerActiveTeam_season_idVideosSystemsRouteImport.update({
    id: '/active/$team_season_id/videos/systems',
    path: '/active/$team_season_id/videos/systems',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRoute =
  AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRouteImport.update({
    id: '/active/$team_season_id/lineups/$id/',
    path: '/active/$team_season_id/lineups/$id/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRoute =
  AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRouteImport.update({
    id: '/active/$team_season_id/lineups/$id/edit',
    path: '/active/$team_season_id/lineups/$id/edit',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRoute =
  AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRouteImport.update({
    id: '/active/$team_season_id/players/$id/',
    path: '/active/$team_season_id/players/$id/',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute;
  '/auth': typeof AuthRouteWithChildren;
  '/$owner': typeof AuthenticatedOwnerRouteWithChildren;
  '/no-organization': typeof AuthenticatedNoOrganizationRoute;
  '/auth/accept-invitation': typeof AuthAcceptInvitationRoute;
  '/auth/reset-password': typeof AuthResetPasswordRoute;
  '/auth/signin': typeof AuthSigninRoute;
  '/auth/signup': typeof AuthSignupRoute;
  '/$owner/ghost': typeof AuthenticatedOwnerGhostRoute;
  '/$owner/plan': typeof AuthenticatedOwnerPlanRoute;
  '/$owner/projection': typeof AuthenticatedOwnerProjectionRoute;
  '/$owner/scout': typeof AuthenticatedOwnerScoutRoute;
  '/$owner/settings': typeof AuthenticatedOwnerSettingsRouteWithChildren;
  '/$owner/design': typeof AuthenticatedOwnerDesignLazyRouteWithChildren;
  '/$owner/': typeof AuthenticatedOwnerIndexRoute;
  '/$owner/account/settings': typeof AuthenticatedOwnerAccountSettingsRouteWithChildren;
  '/$owner/players/new': typeof AuthenticatedOwnerPlayersNewRoute;
  '/$owner/settings/access': typeof AuthenticatedOwnerSettingsAccessRoute;
  '/$owner/settings/subscription': typeof AuthenticatedOwnerSettingsSubscriptionRoute;
  '/$owner/design/colors': typeof AuthenticatedOwnerDesignColorsLazyRoute;
  '/$owner/design/forms': typeof AuthenticatedOwnerDesignFormsLazyRoute;
  '/$owner/design/tables': typeof AuthenticatedOwnerDesignTablesLazyRoute;
  '/$owner/design/typography': typeof AuthenticatedOwnerDesignTypographyLazyRoute;
  '/$owner/activity/': typeof AuthenticatedOwnerActivityIndexRoute;
  '/$owner/database/': typeof AuthenticatedOwnerDatabaseIndexRoute;
  '/$owner/players/': typeof AuthenticatedOwnerPlayersIndexRoute;
  '/$owner/reports/': typeof AuthenticatedOwnerReportsIndexRoute;
  '/$owner/settings/': typeof AuthenticatedOwnerSettingsIndexRoute;
  '/$owner/design/': typeof AuthenticatedOwnerDesignIndexLazyRoute;
  '/$owner/account/settings/password': typeof AuthenticatedOwnerAccountSettingsPasswordRoute;
  '/$owner/account/settings/sessions': typeof AuthenticatedOwnerAccountSettingsSessionsRoute;
  '/$owner/account/settings/sign-in': typeof AuthenticatedOwnerAccountSettingsSignInRoute;
  '/$owner/account/settings/subscription': typeof AuthenticatedOwnerAccountSettingsSubscriptionRoute;
  '/$owner/active/$team_season_id/calendar': typeof AuthenticatedOwnerActiveTeam_season_idCalendarRoute;
  '/$owner/active/$team_season_id/depth-chart': typeof AuthenticatedOwnerActiveTeam_season_idDepthChartRoute;
  '/$owner/active/$team_season_id/portal': typeof AuthenticatedOwnerActiveTeam_season_idPortalRoute;
  '/$owner/active/$team_season_id/stats': typeof AuthenticatedOwnerActiveTeam_season_idStatsRoute;
  '/$owner/players/$id/edit': typeof AuthenticatedOwnerPlayersIdEditRoute;
  '/$owner/account/settings/': typeof AuthenticatedOwnerAccountSettingsIndexRoute;
  '/$owner/active/$team_season_id/': typeof AuthenticatedOwnerActiveTeam_season_idIndexRoute;
  '/$owner/activity/$id/': typeof AuthenticatedOwnerActivityIdIndexRoute;
  '/$owner/database/$id/': typeof AuthenticatedOwnerDatabaseIdIndexRoute;
  '/$owner/planning/$team_season_id/': typeof AuthenticatedOwnerPlanningTeam_season_idIndexRoute;
  '/$owner/players/$id/': typeof AuthenticatedOwnerPlayersIdIndexRoute;
  '/$owner/reports/$id/': typeof AuthenticatedOwnerReportsIdIndexRoute;
  '/$owner/active/$team_season_id/lineups/new': typeof AuthenticatedOwnerActiveTeam_season_idLineupsNewRoute;
  '/$owner/active/$team_season_id/videos/systems': typeof AuthenticatedOwnerActiveTeam_season_idVideosSystemsRoute;
  '/$owner/active/$team_season_id/lineups/': typeof AuthenticatedOwnerActiveTeam_season_idLineupsIndexRoute;
  '/$owner/active/$team_season_id/players/': typeof AuthenticatedOwnerActiveTeam_season_idPlayersIndexRoute;
  '/$owner/active/$team_season_id/practice-plans/': typeof AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRoute;
  '/$owner/active/$team_season_id/videos/': typeof AuthenticatedOwnerActiveTeam_season_idVideosIndexRoute;
  '/$owner/active/$team_season_id/lineups/$id/edit': typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRoute;
  '/$owner/active/$team_season_id/lineups/$id/': typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRoute;
  '/$owner/active/$team_season_id/players/$id/': typeof AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRoute;
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren;
  '/no-organization': typeof AuthenticatedNoOrganizationRoute;
  '/auth/accept-invitation': typeof AuthAcceptInvitationRoute;
  '/auth/reset-password': typeof AuthResetPasswordRoute;
  '/auth/signin': typeof AuthSigninRoute;
  '/auth/signup': typeof AuthSignupRoute;
  '/': typeof AuthenticatedIndexRoute;
  '/$owner/ghost': typeof AuthenticatedOwnerGhostRoute;
  '/$owner/plan': typeof AuthenticatedOwnerPlanRoute;
  '/$owner/projection': typeof AuthenticatedOwnerProjectionRoute;
  '/$owner/scout': typeof AuthenticatedOwnerScoutRoute;
  '/$owner': typeof AuthenticatedOwnerIndexRoute;
  '/$owner/players/new': typeof AuthenticatedOwnerPlayersNewRoute;
  '/$owner/settings/access': typeof AuthenticatedOwnerSettingsAccessRoute;
  '/$owner/settings/subscription': typeof AuthenticatedOwnerSettingsSubscriptionRoute;
  '/$owner/design/colors': typeof AuthenticatedOwnerDesignColorsLazyRoute;
  '/$owner/design/forms': typeof AuthenticatedOwnerDesignFormsLazyRoute;
  '/$owner/design/tables': typeof AuthenticatedOwnerDesignTablesLazyRoute;
  '/$owner/design/typography': typeof AuthenticatedOwnerDesignTypographyLazyRoute;
  '/$owner/activity': typeof AuthenticatedOwnerActivityIndexRoute;
  '/$owner/database': typeof AuthenticatedOwnerDatabaseIndexRoute;
  '/$owner/players': typeof AuthenticatedOwnerPlayersIndexRoute;
  '/$owner/reports': typeof AuthenticatedOwnerReportsIndexRoute;
  '/$owner/settings': typeof AuthenticatedOwnerSettingsIndexRoute;
  '/$owner/design': typeof AuthenticatedOwnerDesignIndexLazyRoute;
  '/$owner/account/settings/password': typeof AuthenticatedOwnerAccountSettingsPasswordRoute;
  '/$owner/account/settings/sessions': typeof AuthenticatedOwnerAccountSettingsSessionsRoute;
  '/$owner/account/settings/sign-in': typeof AuthenticatedOwnerAccountSettingsSignInRoute;
  '/$owner/account/settings/subscription': typeof AuthenticatedOwnerAccountSettingsSubscriptionRoute;
  '/$owner/active/$team_season_id/calendar': typeof AuthenticatedOwnerActiveTeam_season_idCalendarRoute;
  '/$owner/active/$team_season_id/depth-chart': typeof AuthenticatedOwnerActiveTeam_season_idDepthChartRoute;
  '/$owner/active/$team_season_id/portal': typeof AuthenticatedOwnerActiveTeam_season_idPortalRoute;
  '/$owner/active/$team_season_id/stats': typeof AuthenticatedOwnerActiveTeam_season_idStatsRoute;
  '/$owner/players/$id/edit': typeof AuthenticatedOwnerPlayersIdEditRoute;
  '/$owner/account/settings': typeof AuthenticatedOwnerAccountSettingsIndexRoute;
  '/$owner/active/$team_season_id': typeof AuthenticatedOwnerActiveTeam_season_idIndexRoute;
  '/$owner/activity/$id': typeof AuthenticatedOwnerActivityIdIndexRoute;
  '/$owner/database/$id': typeof AuthenticatedOwnerDatabaseIdIndexRoute;
  '/$owner/planning/$team_season_id': typeof AuthenticatedOwnerPlanningTeam_season_idIndexRoute;
  '/$owner/players/$id': typeof AuthenticatedOwnerPlayersIdIndexRoute;
  '/$owner/reports/$id': typeof AuthenticatedOwnerReportsIdIndexRoute;
  '/$owner/active/$team_season_id/lineups/new': typeof AuthenticatedOwnerActiveTeam_season_idLineupsNewRoute;
  '/$owner/active/$team_season_id/videos/systems': typeof AuthenticatedOwnerActiveTeam_season_idVideosSystemsRoute;
  '/$owner/active/$team_season_id/lineups': typeof AuthenticatedOwnerActiveTeam_season_idLineupsIndexRoute;
  '/$owner/active/$team_season_id/players': typeof AuthenticatedOwnerActiveTeam_season_idPlayersIndexRoute;
  '/$owner/active/$team_season_id/practice-plans': typeof AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRoute;
  '/$owner/active/$team_season_id/videos': typeof AuthenticatedOwnerActiveTeam_season_idVideosIndexRoute;
  '/$owner/active/$team_season_id/lineups/$id/edit': typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRoute;
  '/$owner/active/$team_season_id/lineups/$id': typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRoute;
  '/$owner/active/$team_season_id/players/$id': typeof AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/auth': typeof AuthRouteWithChildren;
  '/_authenticated/$owner': typeof AuthenticatedOwnerRouteWithChildren;
  '/_authenticated/no-organization': typeof AuthenticatedNoOrganizationRoute;
  '/auth/accept-invitation': typeof AuthAcceptInvitationRoute;
  '/auth/reset-password': typeof AuthResetPasswordRoute;
  '/auth/signin': typeof AuthSigninRoute;
  '/auth/signup': typeof AuthSignupRoute;
  '/_authenticated/': typeof AuthenticatedIndexRoute;
  '/_authenticated/$owner/ghost': typeof AuthenticatedOwnerGhostRoute;
  '/_authenticated/$owner/plan': typeof AuthenticatedOwnerPlanRoute;
  '/_authenticated/$owner/projection': typeof AuthenticatedOwnerProjectionRoute;
  '/_authenticated/$owner/scout': typeof AuthenticatedOwnerScoutRoute;
  '/_authenticated/$owner/settings': typeof AuthenticatedOwnerSettingsRouteWithChildren;
  '/_authenticated/$owner/design': typeof AuthenticatedOwnerDesignLazyRouteWithChildren;
  '/_authenticated/$owner/': typeof AuthenticatedOwnerIndexRoute;
  '/_authenticated/$owner/account/settings': typeof AuthenticatedOwnerAccountSettingsRouteWithChildren;
  '/_authenticated/$owner/players/new': typeof AuthenticatedOwnerPlayersNewRoute;
  '/_authenticated/$owner/settings/access': typeof AuthenticatedOwnerSettingsAccessRoute;
  '/_authenticated/$owner/settings/subscription': typeof AuthenticatedOwnerSettingsSubscriptionRoute;
  '/_authenticated/$owner/design/colors': typeof AuthenticatedOwnerDesignColorsLazyRoute;
  '/_authenticated/$owner/design/forms': typeof AuthenticatedOwnerDesignFormsLazyRoute;
  '/_authenticated/$owner/design/tables': typeof AuthenticatedOwnerDesignTablesLazyRoute;
  '/_authenticated/$owner/design/typography': typeof AuthenticatedOwnerDesignTypographyLazyRoute;
  '/_authenticated/$owner/activity/': typeof AuthenticatedOwnerActivityIndexRoute;
  '/_authenticated/$owner/database/': typeof AuthenticatedOwnerDatabaseIndexRoute;
  '/_authenticated/$owner/players/': typeof AuthenticatedOwnerPlayersIndexRoute;
  '/_authenticated/$owner/reports/': typeof AuthenticatedOwnerReportsIndexRoute;
  '/_authenticated/$owner/settings/': typeof AuthenticatedOwnerSettingsIndexRoute;
  '/_authenticated/$owner/design/': typeof AuthenticatedOwnerDesignIndexLazyRoute;
  '/_authenticated/$owner/account/settings/password': typeof AuthenticatedOwnerAccountSettingsPasswordRoute;
  '/_authenticated/$owner/account/settings/sessions': typeof AuthenticatedOwnerAccountSettingsSessionsRoute;
  '/_authenticated/$owner/account/settings/sign-in': typeof AuthenticatedOwnerAccountSettingsSignInRoute;
  '/_authenticated/$owner/account/settings/subscription': typeof AuthenticatedOwnerAccountSettingsSubscriptionRoute;
  '/_authenticated/$owner/active/$team_season_id/calendar': typeof AuthenticatedOwnerActiveTeam_season_idCalendarRoute;
  '/_authenticated/$owner/active/$team_season_id/depth-chart': typeof AuthenticatedOwnerActiveTeam_season_idDepthChartRoute;
  '/_authenticated/$owner/active/$team_season_id/portal': typeof AuthenticatedOwnerActiveTeam_season_idPortalRoute;
  '/_authenticated/$owner/active/$team_season_id/stats': typeof AuthenticatedOwnerActiveTeam_season_idStatsRoute;
  '/_authenticated/$owner/players/$id/edit': typeof AuthenticatedOwnerPlayersIdEditRoute;
  '/_authenticated/$owner/account/settings/': typeof AuthenticatedOwnerAccountSettingsIndexRoute;
  '/_authenticated/$owner/active/$team_season_id/': typeof AuthenticatedOwnerActiveTeam_season_idIndexRoute;
  '/_authenticated/$owner/activity/$id/': typeof AuthenticatedOwnerActivityIdIndexRoute;
  '/_authenticated/$owner/database/$id/': typeof AuthenticatedOwnerDatabaseIdIndexRoute;
  '/_authenticated/$owner/planning/$team_season_id/': typeof AuthenticatedOwnerPlanningTeam_season_idIndexRoute;
  '/_authenticated/$owner/players/$id/': typeof AuthenticatedOwnerPlayersIdIndexRoute;
  '/_authenticated/$owner/reports/$id/': typeof AuthenticatedOwnerReportsIdIndexRoute;
  '/_authenticated/$owner/active/$team_season_id/lineups/new': typeof AuthenticatedOwnerActiveTeam_season_idLineupsNewRoute;
  '/_authenticated/$owner/active/$team_season_id/videos/systems': typeof AuthenticatedOwnerActiveTeam_season_idVideosSystemsRoute;
  '/_authenticated/$owner/active/$team_season_id/lineups/': typeof AuthenticatedOwnerActiveTeam_season_idLineupsIndexRoute;
  '/_authenticated/$owner/active/$team_season_id/players/': typeof AuthenticatedOwnerActiveTeam_season_idPlayersIndexRoute;
  '/_authenticated/$owner/active/$team_season_id/practice-plans/': typeof AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRoute;
  '/_authenticated/$owner/active/$team_season_id/videos/': typeof AuthenticatedOwnerActiveTeam_season_idVideosIndexRoute;
  '/_authenticated/$owner/active/$team_season_id/lineups/$id/edit': typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRoute;
  '/_authenticated/$owner/active/$team_season_id/lineups/$id/': typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRoute;
  '/_authenticated/$owner/active/$team_season_id/players/$id/': typeof AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/auth'
    | '/$owner'
    | '/no-organization'
    | '/auth/accept-invitation'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/$owner/ghost'
    | '/$owner/plan'
    | '/$owner/projection'
    | '/$owner/scout'
    | '/$owner/settings'
    | '/$owner/design'
    | '/$owner/'
    | '/$owner/account/settings'
    | '/$owner/players/new'
    | '/$owner/settings/access'
    | '/$owner/settings/subscription'
    | '/$owner/design/colors'
    | '/$owner/design/forms'
    | '/$owner/design/tables'
    | '/$owner/design/typography'
    | '/$owner/activity/'
    | '/$owner/database/'
    | '/$owner/players/'
    | '/$owner/reports/'
    | '/$owner/settings/'
    | '/$owner/design/'
    | '/$owner/account/settings/password'
    | '/$owner/account/settings/sessions'
    | '/$owner/account/settings/sign-in'
    | '/$owner/account/settings/subscription'
    | '/$owner/active/$team_season_id/calendar'
    | '/$owner/active/$team_season_id/depth-chart'
    | '/$owner/active/$team_season_id/portal'
    | '/$owner/active/$team_season_id/stats'
    | '/$owner/players/$id/edit'
    | '/$owner/account/settings/'
    | '/$owner/active/$team_season_id/'
    | '/$owner/activity/$id/'
    | '/$owner/database/$id/'
    | '/$owner/planning/$team_season_id/'
    | '/$owner/players/$id/'
    | '/$owner/reports/$id/'
    | '/$owner/active/$team_season_id/lineups/new'
    | '/$owner/active/$team_season_id/videos/systems'
    | '/$owner/active/$team_season_id/lineups/'
    | '/$owner/active/$team_season_id/players/'
    | '/$owner/active/$team_season_id/practice-plans/'
    | '/$owner/active/$team_season_id/videos/'
    | '/$owner/active/$team_season_id/lineups/$id/edit'
    | '/$owner/active/$team_season_id/lineups/$id/'
    | '/$owner/active/$team_season_id/players/$id/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/auth'
    | '/no-organization'
    | '/auth/accept-invitation'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/'
    | '/$owner/ghost'
    | '/$owner/plan'
    | '/$owner/projection'
    | '/$owner/scout'
    | '/$owner'
    | '/$owner/players/new'
    | '/$owner/settings/access'
    | '/$owner/settings/subscription'
    | '/$owner/design/colors'
    | '/$owner/design/forms'
    | '/$owner/design/tables'
    | '/$owner/design/typography'
    | '/$owner/activity'
    | '/$owner/database'
    | '/$owner/players'
    | '/$owner/reports'
    | '/$owner/settings'
    | '/$owner/design'
    | '/$owner/account/settings/password'
    | '/$owner/account/settings/sessions'
    | '/$owner/account/settings/sign-in'
    | '/$owner/account/settings/subscription'
    | '/$owner/active/$team_season_id/calendar'
    | '/$owner/active/$team_season_id/depth-chart'
    | '/$owner/active/$team_season_id/portal'
    | '/$owner/active/$team_season_id/stats'
    | '/$owner/players/$id/edit'
    | '/$owner/account/settings'
    | '/$owner/active/$team_season_id'
    | '/$owner/activity/$id'
    | '/$owner/database/$id'
    | '/$owner/planning/$team_season_id'
    | '/$owner/players/$id'
    | '/$owner/reports/$id'
    | '/$owner/active/$team_season_id/lineups/new'
    | '/$owner/active/$team_season_id/videos/systems'
    | '/$owner/active/$team_season_id/lineups'
    | '/$owner/active/$team_season_id/players'
    | '/$owner/active/$team_season_id/practice-plans'
    | '/$owner/active/$team_season_id/videos'
    | '/$owner/active/$team_season_id/lineups/$id/edit'
    | '/$owner/active/$team_season_id/lineups/$id'
    | '/$owner/active/$team_season_id/players/$id';
  id:
    | '__root__'
    | '/_authenticated'
    | '/auth'
    | '/_authenticated/$owner'
    | '/_authenticated/no-organization'
    | '/auth/accept-invitation'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/_authenticated/'
    | '/_authenticated/$owner/ghost'
    | '/_authenticated/$owner/plan'
    | '/_authenticated/$owner/projection'
    | '/_authenticated/$owner/scout'
    | '/_authenticated/$owner/settings'
    | '/_authenticated/$owner/design'
    | '/_authenticated/$owner/'
    | '/_authenticated/$owner/account/settings'
    | '/_authenticated/$owner/players/new'
    | '/_authenticated/$owner/settings/access'
    | '/_authenticated/$owner/settings/subscription'
    | '/_authenticated/$owner/design/colors'
    | '/_authenticated/$owner/design/forms'
    | '/_authenticated/$owner/design/tables'
    | '/_authenticated/$owner/design/typography'
    | '/_authenticated/$owner/activity/'
    | '/_authenticated/$owner/database/'
    | '/_authenticated/$owner/players/'
    | '/_authenticated/$owner/reports/'
    | '/_authenticated/$owner/settings/'
    | '/_authenticated/$owner/design/'
    | '/_authenticated/$owner/account/settings/password'
    | '/_authenticated/$owner/account/settings/sessions'
    | '/_authenticated/$owner/account/settings/sign-in'
    | '/_authenticated/$owner/account/settings/subscription'
    | '/_authenticated/$owner/active/$team_season_id/calendar'
    | '/_authenticated/$owner/active/$team_season_id/depth-chart'
    | '/_authenticated/$owner/active/$team_season_id/portal'
    | '/_authenticated/$owner/active/$team_season_id/stats'
    | '/_authenticated/$owner/players/$id/edit'
    | '/_authenticated/$owner/account/settings/'
    | '/_authenticated/$owner/active/$team_season_id/'
    | '/_authenticated/$owner/activity/$id/'
    | '/_authenticated/$owner/database/$id/'
    | '/_authenticated/$owner/planning/$team_season_id/'
    | '/_authenticated/$owner/players/$id/'
    | '/_authenticated/$owner/reports/$id/'
    | '/_authenticated/$owner/active/$team_season_id/lineups/new'
    | '/_authenticated/$owner/active/$team_season_id/videos/systems'
    | '/_authenticated/$owner/active/$team_season_id/lineups/'
    | '/_authenticated/$owner/active/$team_season_id/players/'
    | '/_authenticated/$owner/active/$team_season_id/practice-plans/'
    | '/_authenticated/$owner/active/$team_season_id/videos/'
    | '/_authenticated/$owner/active/$team_season_id/lineups/$id/edit'
    | '/_authenticated/$owner/active/$team_season_id/lineups/$id/'
    | '/_authenticated/$owner/active/$team_season_id/players/$id/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  AuthRoute: typeof AuthRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/auth': {
      id: '/auth';
      path: '/auth';
      fullPath: '/auth';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/': {
      id: '/_authenticated/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/$owner': {
      id: '/_authenticated/$owner';
      path: '/$owner';
      fullPath: '/$owner';
      preLoaderRoute: typeof AuthenticatedOwnerRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/no-organization': {
      id: '/_authenticated/no-organization';
      path: '/no-organization';
      fullPath: '/no-organization';
      preLoaderRoute: typeof AuthenticatedNoOrganizationRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/auth/accept-invitation': {
      id: '/auth/accept-invitation';
      path: '/accept-invitation';
      fullPath: '/auth/accept-invitation';
      preLoaderRoute: typeof AuthAcceptInvitationRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/auth/reset-password': {
      id: '/auth/reset-password';
      path: '/reset-password';
      fullPath: '/auth/reset-password';
      preLoaderRoute: typeof AuthResetPasswordRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/auth/signin': {
      id: '/auth/signin';
      path: '/signin';
      fullPath: '/auth/signin';
      preLoaderRoute: typeof AuthSigninRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/auth/signup': {
      id: '/auth/signup';
      path: '/signup';
      fullPath: '/auth/signup';
      preLoaderRoute: typeof AuthSignupRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_authenticated/$owner/': {
      id: '/_authenticated/$owner/';
      path: '/';
      fullPath: '/$owner/';
      preLoaderRoute: typeof AuthenticatedOwnerIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/design': {
      id: '/_authenticated/$owner/design';
      path: '/design';
      fullPath: '/$owner/design';
      preLoaderRoute: typeof AuthenticatedOwnerDesignLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/ghost': {
      id: '/_authenticated/$owner/ghost';
      path: '/ghost';
      fullPath: '/$owner/ghost';
      preLoaderRoute: typeof AuthenticatedOwnerGhostRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/plan': {
      id: '/_authenticated/$owner/plan';
      path: '/plan';
      fullPath: '/$owner/plan';
      preLoaderRoute: typeof AuthenticatedOwnerPlanRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/projection': {
      id: '/_authenticated/$owner/projection';
      path: '/projection';
      fullPath: '/$owner/projection';
      preLoaderRoute: typeof AuthenticatedOwnerProjectionRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/scout': {
      id: '/_authenticated/$owner/scout';
      path: '/scout';
      fullPath: '/$owner/scout';
      preLoaderRoute: typeof AuthenticatedOwnerScoutRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/settings': {
      id: '/_authenticated/$owner/settings';
      path: '/settings';
      fullPath: '/$owner/settings';
      preLoaderRoute: typeof AuthenticatedOwnerSettingsRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/account/settings': {
      id: '/_authenticated/$owner/account/settings';
      path: '/account/settings';
      fullPath: '/$owner/account/settings';
      preLoaderRoute: typeof AuthenticatedOwnerAccountSettingsRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/activity/': {
      id: '/_authenticated/$owner/activity/';
      path: '/activity';
      fullPath: '/$owner/activity/';
      preLoaderRoute: typeof AuthenticatedOwnerActivityIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/database/': {
      id: '/_authenticated/$owner/database/';
      path: '/database';
      fullPath: '/$owner/database/';
      preLoaderRoute: typeof AuthenticatedOwnerDatabaseIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/design/': {
      id: '/_authenticated/$owner/design/';
      path: '/';
      fullPath: '/$owner/design/';
      preLoaderRoute: typeof AuthenticatedOwnerDesignIndexLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerDesignLazyRoute;
    };
    '/_authenticated/$owner/design/colors': {
      id: '/_authenticated/$owner/design/colors';
      path: '/colors';
      fullPath: '/$owner/design/colors';
      preLoaderRoute: typeof AuthenticatedOwnerDesignColorsLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerDesignLazyRoute;
    };
    '/_authenticated/$owner/design/forms': {
      id: '/_authenticated/$owner/design/forms';
      path: '/forms';
      fullPath: '/$owner/design/forms';
      preLoaderRoute: typeof AuthenticatedOwnerDesignFormsLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerDesignLazyRoute;
    };
    '/_authenticated/$owner/design/tables': {
      id: '/_authenticated/$owner/design/tables';
      path: '/tables';
      fullPath: '/$owner/design/tables';
      preLoaderRoute: typeof AuthenticatedOwnerDesignTablesLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerDesignLazyRoute;
    };
    '/_authenticated/$owner/design/typography': {
      id: '/_authenticated/$owner/design/typography';
      path: '/typography';
      fullPath: '/$owner/design/typography';
      preLoaderRoute: typeof AuthenticatedOwnerDesignTypographyLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerDesignLazyRoute;
    };
    '/_authenticated/$owner/players/': {
      id: '/_authenticated/$owner/players/';
      path: '/players';
      fullPath: '/$owner/players/';
      preLoaderRoute: typeof AuthenticatedOwnerPlayersIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/players/new': {
      id: '/_authenticated/$owner/players/new';
      path: '/players/new';
      fullPath: '/$owner/players/new';
      preLoaderRoute: typeof AuthenticatedOwnerPlayersNewRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/reports/': {
      id: '/_authenticated/$owner/reports/';
      path: '/reports';
      fullPath: '/$owner/reports/';
      preLoaderRoute: typeof AuthenticatedOwnerReportsIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/settings/': {
      id: '/_authenticated/$owner/settings/';
      path: '/';
      fullPath: '/$owner/settings/';
      preLoaderRoute: typeof AuthenticatedOwnerSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerSettingsRoute;
    };
    '/_authenticated/$owner/settings/access': {
      id: '/_authenticated/$owner/settings/access';
      path: '/access';
      fullPath: '/$owner/settings/access';
      preLoaderRoute: typeof AuthenticatedOwnerSettingsAccessRouteImport;
      parentRoute: typeof AuthenticatedOwnerSettingsRoute;
    };
    '/_authenticated/$owner/settings/subscription': {
      id: '/_authenticated/$owner/settings/subscription';
      path: '/subscription';
      fullPath: '/$owner/settings/subscription';
      preLoaderRoute: typeof AuthenticatedOwnerSettingsSubscriptionRouteImport;
      parentRoute: typeof AuthenticatedOwnerSettingsRoute;
    };
    '/_authenticated/$owner/account/settings/': {
      id: '/_authenticated/$owner/account/settings/';
      path: '/';
      fullPath: '/$owner/account/settings/';
      preLoaderRoute: typeof AuthenticatedOwnerAccountSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerAccountSettingsRoute;
    };
    '/_authenticated/$owner/account/settings/password': {
      id: '/_authenticated/$owner/account/settings/password';
      path: '/password';
      fullPath: '/$owner/account/settings/password';
      preLoaderRoute: typeof AuthenticatedOwnerAccountSettingsPasswordRouteImport;
      parentRoute: typeof AuthenticatedOwnerAccountSettingsRoute;
    };
    '/_authenticated/$owner/account/settings/sessions': {
      id: '/_authenticated/$owner/account/settings/sessions';
      path: '/sessions';
      fullPath: '/$owner/account/settings/sessions';
      preLoaderRoute: typeof AuthenticatedOwnerAccountSettingsSessionsRouteImport;
      parentRoute: typeof AuthenticatedOwnerAccountSettingsRoute;
    };
    '/_authenticated/$owner/account/settings/sign-in': {
      id: '/_authenticated/$owner/account/settings/sign-in';
      path: '/sign-in';
      fullPath: '/$owner/account/settings/sign-in';
      preLoaderRoute: typeof AuthenticatedOwnerAccountSettingsSignInRouteImport;
      parentRoute: typeof AuthenticatedOwnerAccountSettingsRoute;
    };
    '/_authenticated/$owner/account/settings/subscription': {
      id: '/_authenticated/$owner/account/settings/subscription';
      path: '/subscription';
      fullPath: '/$owner/account/settings/subscription';
      preLoaderRoute: typeof AuthenticatedOwnerAccountSettingsSubscriptionRouteImport;
      parentRoute: typeof AuthenticatedOwnerAccountSettingsRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/': {
      id: '/_authenticated/$owner/active/$team_season_id/';
      path: '/active/$team_season_id';
      fullPath: '/$owner/active/$team_season_id/';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/calendar': {
      id: '/_authenticated/$owner/active/$team_season_id/calendar';
      path: '/active/$team_season_id/calendar';
      fullPath: '/$owner/active/$team_season_id/calendar';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idCalendarRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/depth-chart': {
      id: '/_authenticated/$owner/active/$team_season_id/depth-chart';
      path: '/active/$team_season_id/depth-chart';
      fullPath: '/$owner/active/$team_season_id/depth-chart';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idDepthChartRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/portal': {
      id: '/_authenticated/$owner/active/$team_season_id/portal';
      path: '/active/$team_season_id/portal';
      fullPath: '/$owner/active/$team_season_id/portal';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idPortalRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/stats': {
      id: '/_authenticated/$owner/active/$team_season_id/stats';
      path: '/active/$team_season_id/stats';
      fullPath: '/$owner/active/$team_season_id/stats';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idStatsRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/activity/$id/': {
      id: '/_authenticated/$owner/activity/$id/';
      path: '/activity/$id';
      fullPath: '/$owner/activity/$id/';
      preLoaderRoute: typeof AuthenticatedOwnerActivityIdIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/database/$id/': {
      id: '/_authenticated/$owner/database/$id/';
      path: '/database/$id';
      fullPath: '/$owner/database/$id/';
      preLoaderRoute: typeof AuthenticatedOwnerDatabaseIdIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/planning/$team_season_id/': {
      id: '/_authenticated/$owner/planning/$team_season_id/';
      path: '/planning/$team_season_id';
      fullPath: '/$owner/planning/$team_season_id/';
      preLoaderRoute: typeof AuthenticatedOwnerPlanningTeam_season_idIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/players/$id/': {
      id: '/_authenticated/$owner/players/$id/';
      path: '/players/$id';
      fullPath: '/$owner/players/$id/';
      preLoaderRoute: typeof AuthenticatedOwnerPlayersIdIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/players/$id/edit': {
      id: '/_authenticated/$owner/players/$id/edit';
      path: '/players/$id/edit';
      fullPath: '/$owner/players/$id/edit';
      preLoaderRoute: typeof AuthenticatedOwnerPlayersIdEditRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/reports/$id/': {
      id: '/_authenticated/$owner/reports/$id/';
      path: '/reports/$id';
      fullPath: '/$owner/reports/$id/';
      preLoaderRoute: typeof AuthenticatedOwnerReportsIdIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/lineups/': {
      id: '/_authenticated/$owner/active/$team_season_id/lineups/';
      path: '/active/$team_season_id/lineups';
      fullPath: '/$owner/active/$team_season_id/lineups/';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idLineupsIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/lineups/new': {
      id: '/_authenticated/$owner/active/$team_season_id/lineups/new';
      path: '/active/$team_season_id/lineups/new';
      fullPath: '/$owner/active/$team_season_id/lineups/new';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idLineupsNewRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/players/': {
      id: '/_authenticated/$owner/active/$team_season_id/players/';
      path: '/active/$team_season_id/players';
      fullPath: '/$owner/active/$team_season_id/players/';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idPlayersIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/practice-plans/': {
      id: '/_authenticated/$owner/active/$team_season_id/practice-plans/';
      path: '/active/$team_season_id/practice-plans';
      fullPath: '/$owner/active/$team_season_id/practice-plans/';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/videos/': {
      id: '/_authenticated/$owner/active/$team_season_id/videos/';
      path: '/active/$team_season_id/videos';
      fullPath: '/$owner/active/$team_season_id/videos/';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idVideosIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/videos/systems': {
      id: '/_authenticated/$owner/active/$team_season_id/videos/systems';
      path: '/active/$team_season_id/videos/systems';
      fullPath: '/$owner/active/$team_season_id/videos/systems';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idVideosSystemsRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/lineups/$id/': {
      id: '/_authenticated/$owner/active/$team_season_id/lineups/$id/';
      path: '/active/$team_season_id/lineups/$id';
      fullPath: '/$owner/active/$team_season_id/lineups/$id/';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/lineups/$id/edit': {
      id: '/_authenticated/$owner/active/$team_season_id/lineups/$id/edit';
      path: '/active/$team_season_id/lineups/$id/edit';
      fullPath: '/$owner/active/$team_season_id/lineups/$id/edit';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/active/$team_season_id/players/$id/': {
      id: '/_authenticated/$owner/active/$team_season_id/players/$id/';
      path: '/active/$team_season_id/players/$id';
      fullPath: '/$owner/active/$team_season_id/players/$id/';
      preLoaderRoute: typeof AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
  }
}

interface AuthenticatedOwnerSettingsRouteChildren {
  AuthenticatedOwnerSettingsAccessRoute: typeof AuthenticatedOwnerSettingsAccessRoute;
  AuthenticatedOwnerSettingsSubscriptionRoute: typeof AuthenticatedOwnerSettingsSubscriptionRoute;
  AuthenticatedOwnerSettingsIndexRoute: typeof AuthenticatedOwnerSettingsIndexRoute;
}

const AuthenticatedOwnerSettingsRouteChildren: AuthenticatedOwnerSettingsRouteChildren =
  {
    AuthenticatedOwnerSettingsAccessRoute:
      AuthenticatedOwnerSettingsAccessRoute,
    AuthenticatedOwnerSettingsSubscriptionRoute:
      AuthenticatedOwnerSettingsSubscriptionRoute,
    AuthenticatedOwnerSettingsIndexRoute: AuthenticatedOwnerSettingsIndexRoute,
  };

const AuthenticatedOwnerSettingsRouteWithChildren =
  AuthenticatedOwnerSettingsRoute._addFileChildren(
    AuthenticatedOwnerSettingsRouteChildren,
  );

interface AuthenticatedOwnerDesignLazyRouteChildren {
  AuthenticatedOwnerDesignColorsLazyRoute: typeof AuthenticatedOwnerDesignColorsLazyRoute;
  AuthenticatedOwnerDesignFormsLazyRoute: typeof AuthenticatedOwnerDesignFormsLazyRoute;
  AuthenticatedOwnerDesignTablesLazyRoute: typeof AuthenticatedOwnerDesignTablesLazyRoute;
  AuthenticatedOwnerDesignTypographyLazyRoute: typeof AuthenticatedOwnerDesignTypographyLazyRoute;
  AuthenticatedOwnerDesignIndexLazyRoute: typeof AuthenticatedOwnerDesignIndexLazyRoute;
}

const AuthenticatedOwnerDesignLazyRouteChildren: AuthenticatedOwnerDesignLazyRouteChildren =
  {
    AuthenticatedOwnerDesignColorsLazyRoute:
      AuthenticatedOwnerDesignColorsLazyRoute,
    AuthenticatedOwnerDesignFormsLazyRoute:
      AuthenticatedOwnerDesignFormsLazyRoute,
    AuthenticatedOwnerDesignTablesLazyRoute:
      AuthenticatedOwnerDesignTablesLazyRoute,
    AuthenticatedOwnerDesignTypographyLazyRoute:
      AuthenticatedOwnerDesignTypographyLazyRoute,
    AuthenticatedOwnerDesignIndexLazyRoute:
      AuthenticatedOwnerDesignIndexLazyRoute,
  };

const AuthenticatedOwnerDesignLazyRouteWithChildren =
  AuthenticatedOwnerDesignLazyRoute._addFileChildren(
    AuthenticatedOwnerDesignLazyRouteChildren,
  );

interface AuthenticatedOwnerAccountSettingsRouteChildren {
  AuthenticatedOwnerAccountSettingsPasswordRoute: typeof AuthenticatedOwnerAccountSettingsPasswordRoute;
  AuthenticatedOwnerAccountSettingsSessionsRoute: typeof AuthenticatedOwnerAccountSettingsSessionsRoute;
  AuthenticatedOwnerAccountSettingsSignInRoute: typeof AuthenticatedOwnerAccountSettingsSignInRoute;
  AuthenticatedOwnerAccountSettingsSubscriptionRoute: typeof AuthenticatedOwnerAccountSettingsSubscriptionRoute;
  AuthenticatedOwnerAccountSettingsIndexRoute: typeof AuthenticatedOwnerAccountSettingsIndexRoute;
}

const AuthenticatedOwnerAccountSettingsRouteChildren: AuthenticatedOwnerAccountSettingsRouteChildren =
  {
    AuthenticatedOwnerAccountSettingsPasswordRoute:
      AuthenticatedOwnerAccountSettingsPasswordRoute,
    AuthenticatedOwnerAccountSettingsSessionsRoute:
      AuthenticatedOwnerAccountSettingsSessionsRoute,
    AuthenticatedOwnerAccountSettingsSignInRoute:
      AuthenticatedOwnerAccountSettingsSignInRoute,
    AuthenticatedOwnerAccountSettingsSubscriptionRoute:
      AuthenticatedOwnerAccountSettingsSubscriptionRoute,
    AuthenticatedOwnerAccountSettingsIndexRoute:
      AuthenticatedOwnerAccountSettingsIndexRoute,
  };

const AuthenticatedOwnerAccountSettingsRouteWithChildren =
  AuthenticatedOwnerAccountSettingsRoute._addFileChildren(
    AuthenticatedOwnerAccountSettingsRouteChildren,
  );

interface AuthenticatedOwnerRouteChildren {
  AuthenticatedOwnerGhostRoute: typeof AuthenticatedOwnerGhostRoute;
  AuthenticatedOwnerPlanRoute: typeof AuthenticatedOwnerPlanRoute;
  AuthenticatedOwnerProjectionRoute: typeof AuthenticatedOwnerProjectionRoute;
  AuthenticatedOwnerScoutRoute: typeof AuthenticatedOwnerScoutRoute;
  AuthenticatedOwnerSettingsRoute: typeof AuthenticatedOwnerSettingsRouteWithChildren;
  AuthenticatedOwnerDesignLazyRoute: typeof AuthenticatedOwnerDesignLazyRouteWithChildren;
  AuthenticatedOwnerIndexRoute: typeof AuthenticatedOwnerIndexRoute;
  AuthenticatedOwnerAccountSettingsRoute: typeof AuthenticatedOwnerAccountSettingsRouteWithChildren;
  AuthenticatedOwnerPlayersNewRoute: typeof AuthenticatedOwnerPlayersNewRoute;
  AuthenticatedOwnerActivityIndexRoute: typeof AuthenticatedOwnerActivityIndexRoute;
  AuthenticatedOwnerDatabaseIndexRoute: typeof AuthenticatedOwnerDatabaseIndexRoute;
  AuthenticatedOwnerPlayersIndexRoute: typeof AuthenticatedOwnerPlayersIndexRoute;
  AuthenticatedOwnerReportsIndexRoute: typeof AuthenticatedOwnerReportsIndexRoute;
  AuthenticatedOwnerActiveTeam_season_idCalendarRoute: typeof AuthenticatedOwnerActiveTeam_season_idCalendarRoute;
  AuthenticatedOwnerActiveTeam_season_idDepthChartRoute: typeof AuthenticatedOwnerActiveTeam_season_idDepthChartRoute;
  AuthenticatedOwnerActiveTeam_season_idPortalRoute: typeof AuthenticatedOwnerActiveTeam_season_idPortalRoute;
  AuthenticatedOwnerActiveTeam_season_idStatsRoute: typeof AuthenticatedOwnerActiveTeam_season_idStatsRoute;
  AuthenticatedOwnerPlayersIdEditRoute: typeof AuthenticatedOwnerPlayersIdEditRoute;
  AuthenticatedOwnerActiveTeam_season_idIndexRoute: typeof AuthenticatedOwnerActiveTeam_season_idIndexRoute;
  AuthenticatedOwnerActivityIdIndexRoute: typeof AuthenticatedOwnerActivityIdIndexRoute;
  AuthenticatedOwnerDatabaseIdIndexRoute: typeof AuthenticatedOwnerDatabaseIdIndexRoute;
  AuthenticatedOwnerPlanningTeam_season_idIndexRoute: typeof AuthenticatedOwnerPlanningTeam_season_idIndexRoute;
  AuthenticatedOwnerPlayersIdIndexRoute: typeof AuthenticatedOwnerPlayersIdIndexRoute;
  AuthenticatedOwnerReportsIdIndexRoute: typeof AuthenticatedOwnerReportsIdIndexRoute;
  AuthenticatedOwnerActiveTeam_season_idLineupsNewRoute: typeof AuthenticatedOwnerActiveTeam_season_idLineupsNewRoute;
  AuthenticatedOwnerActiveTeam_season_idVideosSystemsRoute: typeof AuthenticatedOwnerActiveTeam_season_idVideosSystemsRoute;
  AuthenticatedOwnerActiveTeam_season_idLineupsIndexRoute: typeof AuthenticatedOwnerActiveTeam_season_idLineupsIndexRoute;
  AuthenticatedOwnerActiveTeam_season_idPlayersIndexRoute: typeof AuthenticatedOwnerActiveTeam_season_idPlayersIndexRoute;
  AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRoute: typeof AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRoute;
  AuthenticatedOwnerActiveTeam_season_idVideosIndexRoute: typeof AuthenticatedOwnerActiveTeam_season_idVideosIndexRoute;
  AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRoute: typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRoute;
  AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRoute: typeof AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRoute;
  AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRoute: typeof AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRoute;
}

const AuthenticatedOwnerRouteChildren: AuthenticatedOwnerRouteChildren = {
  AuthenticatedOwnerGhostRoute: AuthenticatedOwnerGhostRoute,
  AuthenticatedOwnerPlanRoute: AuthenticatedOwnerPlanRoute,
  AuthenticatedOwnerProjectionRoute: AuthenticatedOwnerProjectionRoute,
  AuthenticatedOwnerScoutRoute: AuthenticatedOwnerScoutRoute,
  AuthenticatedOwnerSettingsRoute: AuthenticatedOwnerSettingsRouteWithChildren,
  AuthenticatedOwnerDesignLazyRoute:
    AuthenticatedOwnerDesignLazyRouteWithChildren,
  AuthenticatedOwnerIndexRoute: AuthenticatedOwnerIndexRoute,
  AuthenticatedOwnerAccountSettingsRoute:
    AuthenticatedOwnerAccountSettingsRouteWithChildren,
  AuthenticatedOwnerPlayersNewRoute: AuthenticatedOwnerPlayersNewRoute,
  AuthenticatedOwnerActivityIndexRoute: AuthenticatedOwnerActivityIndexRoute,
  AuthenticatedOwnerDatabaseIndexRoute: AuthenticatedOwnerDatabaseIndexRoute,
  AuthenticatedOwnerPlayersIndexRoute: AuthenticatedOwnerPlayersIndexRoute,
  AuthenticatedOwnerReportsIndexRoute: AuthenticatedOwnerReportsIndexRoute,
  AuthenticatedOwnerActiveTeam_season_idCalendarRoute:
    AuthenticatedOwnerActiveTeam_season_idCalendarRoute,
  AuthenticatedOwnerActiveTeam_season_idDepthChartRoute:
    AuthenticatedOwnerActiveTeam_season_idDepthChartRoute,
  AuthenticatedOwnerActiveTeam_season_idPortalRoute:
    AuthenticatedOwnerActiveTeam_season_idPortalRoute,
  AuthenticatedOwnerActiveTeam_season_idStatsRoute:
    AuthenticatedOwnerActiveTeam_season_idStatsRoute,
  AuthenticatedOwnerPlayersIdEditRoute: AuthenticatedOwnerPlayersIdEditRoute,
  AuthenticatedOwnerActiveTeam_season_idIndexRoute:
    AuthenticatedOwnerActiveTeam_season_idIndexRoute,
  AuthenticatedOwnerActivityIdIndexRoute:
    AuthenticatedOwnerActivityIdIndexRoute,
  AuthenticatedOwnerDatabaseIdIndexRoute:
    AuthenticatedOwnerDatabaseIdIndexRoute,
  AuthenticatedOwnerPlanningTeam_season_idIndexRoute:
    AuthenticatedOwnerPlanningTeam_season_idIndexRoute,
  AuthenticatedOwnerPlayersIdIndexRoute: AuthenticatedOwnerPlayersIdIndexRoute,
  AuthenticatedOwnerReportsIdIndexRoute: AuthenticatedOwnerReportsIdIndexRoute,
  AuthenticatedOwnerActiveTeam_season_idLineupsNewRoute:
    AuthenticatedOwnerActiveTeam_season_idLineupsNewRoute,
  AuthenticatedOwnerActiveTeam_season_idVideosSystemsRoute:
    AuthenticatedOwnerActiveTeam_season_idVideosSystemsRoute,
  AuthenticatedOwnerActiveTeam_season_idLineupsIndexRoute:
    AuthenticatedOwnerActiveTeam_season_idLineupsIndexRoute,
  AuthenticatedOwnerActiveTeam_season_idPlayersIndexRoute:
    AuthenticatedOwnerActiveTeam_season_idPlayersIndexRoute,
  AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRoute:
    AuthenticatedOwnerActiveTeam_season_idPracticePlansIndexRoute,
  AuthenticatedOwnerActiveTeam_season_idVideosIndexRoute:
    AuthenticatedOwnerActiveTeam_season_idVideosIndexRoute,
  AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRoute:
    AuthenticatedOwnerActiveTeam_season_idLineupsIdEditRoute,
  AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRoute:
    AuthenticatedOwnerActiveTeam_season_idLineupsIdIndexRoute,
  AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRoute:
    AuthenticatedOwnerActiveTeam_season_idPlayersIdIndexRoute,
};

const AuthenticatedOwnerRouteWithChildren =
  AuthenticatedOwnerRoute._addFileChildren(AuthenticatedOwnerRouteChildren);

interface AuthenticatedRouteChildren {
  AuthenticatedOwnerRoute: typeof AuthenticatedOwnerRouteWithChildren;
  AuthenticatedNoOrganizationRoute: typeof AuthenticatedNoOrganizationRoute;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOwnerRoute: AuthenticatedOwnerRouteWithChildren,
  AuthenticatedNoOrganizationRoute: AuthenticatedNoOrganizationRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface AuthRouteChildren {
  AuthAcceptInvitationRoute: typeof AuthAcceptInvitationRoute;
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute;
  AuthSigninRoute: typeof AuthSigninRoute;
  AuthSignupRoute: typeof AuthSignupRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAcceptInvitationRoute: AuthAcceptInvitationRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
